module.exports = __webpack_public_path__ + "static/media/active-teaching-paths.07814d5f.svg";